@if (loginConfig.fastLoginToggleEnabled && fields[0]; as field) {
    <div class="form-control-us-switcher d-flex justify-content-between align-items-center">
        <div class="d-flex us-switcher-label">
            @if (fastLoginIconClasses[field.value]; as iconClass) {
                <vn-icon [name]="iconClass" class="us-switcher-label-icon d-flex align-items-center" size="24" />
            }
            <span class="us-switcher-label-text">{{ field.text }}</span>
            @if (loginContentService.content.messages?.FastLoginInfo) {
                <span [floatUi]="popper.content" class="d-flex align-items-center"><vn-icon name="theme-info-i" size="16" /></span>
                <vn-popper-content cssClass="tooltip-info" #popper>
                    <ng-container content>{{ loginContentService.content.messages?.FastLoginInfo | format: field.text }} </ng-container>
                </vn-popper-content>
            }
        </div>
        <div class="switcher-lg">
            <ds-switch
                name="autologin"
                [attr.id]="field.value"
                [checked]="loginService.fastLoginEnabled"
                (checkedChange)="onValueChange($event ? field.value : fastLoginValues.FastLoginDisabled)" />
        </div>
    </div>
} @else {
    <div class="form-element">
        <ds-segmented-control [fullWidth]="true" [inverse]="false" [activeOption]="activeOption" (activeOptionChange)="onValueChange($event)">
            @for (field of fields; track $index) {
                <ds-segmented-option [title]="field.text ?? ''" [name]="field.value" />
            }
        </ds-segmented-control>
    </div>
}
